import { render, staticRenderFns } from "./SelectAstrolabePopup.vue?vue&type=template&id=48d92581&scoped=true&"
import script from "./SelectAstrolabePopup.vue?vue&type=script&lang=js&"
export * from "./SelectAstrolabePopup.vue?vue&type=script&lang=js&"
import style0 from "./SelectAstrolabePopup.vue?vue&type=style&index=0&id=48d92581&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d92581",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48d92581')) {
      api.createRecord('48d92581', component.options)
    } else {
      api.reload('48d92581', component.options)
    }
    module.hot.accept("./SelectAstrolabePopup.vue?vue&type=template&id=48d92581&scoped=true&", function () {
      api.rerender('48d92581', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SelectAstrolabePopup.vue"
export default component.exports